module.exports = __webpack_public_path__ + "static/media/season-end-header-icon.50f91a97.svg";